import axios from '../../../api/config'
import {
  getStatisticGlossariesAPI,
  getMinSelectableDateAPI,
  getGlossaryPeriodStatisticDataAPI,
  getGlossaryStatisticDataAPI,
  getExamStatisticDataAPI,
  getTypingSingleBasicLesson16StatisticDataAPI,
  getTypingEssayStatisticDataAPI,
  getLast7DaysTypingStatisticDataAPI,
  getLast7DaysVocabularyStatisticDataAPI
} from '../../../api/statisticAPI'

const state = {
  waitForFetching: {
    GLOSSARYLIST: false,
    MINSELECTABLEDATE: false,
    GLOSSARYPERIODDATATOPLOT: false,
    GLOSSARYDATATOPLOT: false,
    EXAMDATATOPLOT: false,
    TYPINGSINGLEBASICLESSON16DATATOPLOT: false,
    TYPINGESSAYDATATOPLOT: false,
    LAST7DAYSTYPINGDATATOPLOT: false,
    LAST7DAYSVOCABULARYDATATOPLOT: false
  },
  glossaryList: [{ id: null, value: null }],
  minSelectableDate: new Date(),
  glossaryPeriodDataToPlotLabels: [],
  glossaryPeriodDataToPlot: null,
  glossaryDataToPlotLabels: [],
  glossaryDataToPlot: null,
  examDataToPlotLabels: [],
  examDataToPlot: null,
  typingSingleBasicLesson16DataToPlotLabels: [],
  typingSingleBasicLesson16DataToPlot: null,
  typingEssayDataToPlotLabels: [],
  typingEssayDataToPlot: null,
  last7DaysTypingDataToPlotLabels: [],
  last7DaysTypingDataToPlot: null,
  last7DaysVocabularyDataToPlotLabels: [],
  last7DaysVocabularyDataToPlot: null
}

const getters = {}

const mutations = {
  setWaitForFetching (state, payload) {
    state.waitForFetching[payload.label] = payload.status
  },
  setGlossaryList (state, payload) {
    state.glossaryList = payload
  },
  setMinSelectableDate (state, date) {
    state.minSelectableDate = date
  },
  setGlossaryPeriodDataToPlot (state, payload) {
    state.glossaryPeriodDataToPlotLabels = payload.labels
    const data = payload.data
    state.glossaryPeriodDataToPlot = [
      {
        label: '总体单字量',
        data: data.all,
        borderColor: 'rgba(244, 155, 100, 0.5)',
        backgroundColor: 'rgba(244, 155, 100, 0.1)'
      },
      {
        label: '个人单字量',
        data: data.individual,
        borderColor: 'rgba(237, 28, 36, 0.5)',
        backgroundColor: 'rgba(237, 28, 36, 0.1)'
      }
    ]
  },
  setGlossaryDataToPlot (state, payload) {
    state.glossaryDataToPlotLabels = payload.labels
    state.glossaryDataToPlot = [
      [
        {
          label: '总体',
          data: payload.all,
          backgroundColor: ['rgba(131, 137, 224, 0.8)', 'rgba(255, 178, 125, 0.8)']
        }
      ],
      [
        {
          label: '个人',
          data: payload.individual,
          backgroundColor: ['rgba(131, 137, 224, 0.8)', 'rgba(255, 178, 125, 0.8)']
        }
      ]
    ]
  },
  setExamDataToPlot (state, payload) {
    state.examDataToPlotLabels = payload.labels
    state.examDataToPlot = [
      {
        label: '总体平均',
        data: payload.all,
        backgroundColor: 'rgba(212, 44, 216, 0.3)'
      },
      {
        label: '个人平均',
        data: payload.individual,
        backgroundColor: 'rgba(184, 74, 91, 0.3)'
      }
    ]
  },
  setTypingSingleBasicLesson16DataToPlot (state, payload) {
    // state.typingSingleBasicLesson16DataToPlotLabels = payload.labels
    // state.typingSingleBasicLesson16DataToPlot = [
    //   {
    //     label: '总体最快',
    //     data: payload.global,
    //     backgroundColor: 'rgba(249, 112, 18, 0.3)'
    //   },
    //   {
    //     label: '个人最快',
    //     data: payload.individual,
    //     backgroundColor: 'rgba(200, 190, 5, 0.3)'
    //   }
    // ]
    state.typingSingleBasicLesson16DataToPlot = [{
      global: payload.global[0],
      individual: payload.individual[0]
    }]
  },
  setTypingEssayDataToPlot (state, payload) {
    // state.typingEssayDataToPlotLabels = payload.labels
    state.typingEssayDataToPlot = [
      {
        label: '总体最快',
        data: payload.global,
        backgroundColor: 'rgba(145, 66, 146, 0.3)'
      },
      {
        label: '个人最快',
        data: payload.individual,
        backgroundColor: 'rgba(77, 177, 220, 0.3)'
      }
    ]
  },
  setLast7DaysTypingDataToPlot (state, payload) {
    state.last7DaysTypingDataToPlotLabels = payload.labels
    const data = payload.data
    state.last7DaysTypingDataToPlot = [
      {
        label: '总体平均练习时间（分钟）',
        data: data.average,
        borderColor: 'rgba(244, 155, 100, 0.5)',
        backgroundColor: 'rgba(244, 155, 100, 0.1)'
      },
      {
        label: '个人练习时间（分钟）',
        data: data.individual,
        borderColor: 'rgba(237, 28, 36, 0.5)',
        backgroundColor: 'rgba(237, 28, 36, 0.1)'
      }
    ]
  },
  setLast7DaysVocabularyDataToPlot (state, payload) {
    state.last7DaysVocabularyDataToPlotLabels = payload.labels
    const data = payload.data
    state.last7DaysVocabularyDataToPlot = [
      {
        label: '总体平均练习时间（分钟）',
        data: data.average,
        borderColor: 'rgba(244, 155, 100, 0.5)',
        backgroundColor: 'rgba(244, 155, 100, 0.1)'
      },
      {
        label: '个人练习时间（分钟）',
        data: data.individual,
        borderColor: 'rgba(237, 28, 36, 0.5)',
        backgroundColor: 'rgba(237, 28, 36, 0.1)'
      }
    ]
  }
}

const actions = {
  getGlossaryList ({ commit }) {
    commit('setWaitForFetching', {
      label: 'GLOSSARYLIST',
      status: true
    })
    axios.get(getStatisticGlossariesAPI)
      .then((response) => {
        commit('setGlossaryList', response.data)
        commit('setWaitForFetching', {
          label: 'GLOSSARYLIST',
          status: false
        })
      })
  },
  getMinSelectableDate ({ commit }) {
    commit('setWaitForFetching', {
      label: 'MINSELECTABLEDATE',
      status: true
    })
    axios.get(getMinSelectableDateAPI)
      .then((response) => {
        commit('setMinSelectableDate', response.data.message.date)
        commit('setWaitForFetching', {
          label: 'MINSELECTABLEDATE',
          status: false
        })
      })
  },
  getGlossaryPeriodStatisticData ({ commit }, payload) {
    commit('setWaitForFetching', {
      label: 'GLOSSARYPERIODDATATOPLOT',
      status: true
    })
    axios.get(`${getGlossaryPeriodStatisticDataAPI}?` +
            `glossaryId=${payload.glossaryId}&` +
            `mode=${payload.mode}&` +
            `fromDate=${payload.fromDate}&` +
            `toDate=${payload.toDate}`)
      .then((response) => {
        commit('setGlossaryPeriodDataToPlot', response.data)
        commit('setWaitForFetching', {
          label: 'GLOSSARYPERIODDATATOPLOT',
          status: false
        })
      })
  },
  getGlossaryStatisticData ({ commit }, payload) {
    commit('setWaitForFetching', {
      label: 'GLOSSARYDATATOPLOT',
      status: true
    })
    axios.get(`${getGlossaryStatisticDataAPI}?` +
              `glossaryId=${payload.glossaryId}`)
      .then((response) => {
        commit('setGlossaryDataToPlot', response.data)
        commit('setWaitForFetching', {
          label: 'GLOSSARYDATATOPLOT',
          status: false
        })
      })
  },
  getExamStatisticData ({ commit }, payload) {
    commit('setWaitForFetching', {
      label: 'EXAMDATATOPLOT',
      status: true
    })
    axios.get(`${getExamStatisticDataAPI}?` +
              `n=${payload.numberOfExams}&` +
              `mode=${payload.mode}`)
      .then((response) => {
        commit('setExamDataToPlot', response.data)
        commit('setWaitForFetching', {
          label: 'EXAMDATATOPLOT',
          status: false
        })
      })
  },

  getTypingSingleBasicLesson16StatisticData ({ commit }) {
    commit('setWaitForFetching', {
      label: 'TYPINGSINGLEBASICLESSON16DATATOPLOT',
      status: true
    })
    axios.get(getTypingSingleBasicLesson16StatisticDataAPI)
      .then((response) => {
        commit('setTypingSingleBasicLesson16DataToPlot', response.data)
        commit('setWaitForFetching', {
          label: 'TYPINGSINGLEBASICLESSON16DATATOPLOT',
          status: false
        })
      })
  },
  getTypingEssayStatisticData ({ commit }) {
    commit('setWaitForFetching', {
      label: 'TYPINGESSAYDATATOPLOT',
      status: true
    })
    axios.get(getTypingEssayStatisticDataAPI)
      .then((response) => {
        commit('setTypingEssayDataToPlot', response.data)
        commit('setWaitForFetching', {
          label: 'TYPINGESSAYDATATOPLOT',
          status: false
        })
      })
  },
  getLast7DaysTypingData ({ commit }) {
    commit('setWaitForFetching', {
      label: 'LAST7DAYSTYPINGDATATOPLOT',
      status: true
    })
    axios.get(getLast7DaysTypingStatisticDataAPI)
      .then((response) => {
        commit('setLast7DaysTypingDataToPlot', response.data)
        commit('setWaitForFetching', {
          label: 'LAST7DAYSTYPINGDATATOPLOT',
          status: false
        })
      })
  },
  getLast7DaysVocabularyData ({ commit }) {
    commit('setWaitForFetching', {
      label: 'LAST7DAYSVOCABULARYDATATOPLOT',
      status: true
    })
    axios.get(getLast7DaysVocabularyStatisticDataAPI)
      .then((response) => {
        commit('setLast7DaysVocabularyDataToPlot', response.data)
        commit('setWaitForFetching', {
          label: 'LAST7DAYSVOCABULARYDATATOPLOT',
          status: false
        })
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
